"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTRO_TEXT = void 0;
const INTRO_TEXT = exports.INTRO_TEXT = 'intro-text';
//# sourceMappingURL=constants.js.map